import { useEffect, useState } from "react";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const WeightLossMedsThroughUs = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);
  const hasError = !!props.errors?.WeightLossMedsThroughUs;

  const handleChange = (value: string) => {
    props.handleStepData("WeightLossMedsThroughUs", value);
    setLastUpdate({ key: "WeightLossMedsThroughUs", value });
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [props.next, props, lastUpdate]);

  return (
    <div>
      <p className="pb-4 font-serif text-h3">
        Do you agree to only obtain weight loss medication through this platform
        moving forward?
      </p>
      <div className="flex gap-3">
        <YesNo
          value={props.data.WeightLossMedsThroughUs}
          onChange={(value) => handleChange(value)}
        />
      </div>
      {hasError && (
        <p className="pt-2 text-sm text-red">
          Please select an option to continue
        </p>
      )}
    </div>
  );
};
